import Dimensions from "react-native-web/dist/exports/Dimensions";
import NonNativeTooltip from './Tooltip';
import NativeToolTip from './Tooltip.native';
const Tooltip = !Dimensions.get('screen').width <= 340 ? NativeToolTip : NonNativeTooltip;
export default Tooltip;